module.exports = __webpack_public_path__ + "img/151.04e24b98.jpg";